import * as React from "react";
import { forwardRef, memo } from "react";
const SvgCircleFill = (props, ref) => (React.createElement("svg", { width: 16, height: 16, viewBox: "0 -960 960 960", ref: ref, ...props },
    React.createElement("path", { d: "M480.276-87.87q-81.189 0-152.621-30.617t-124.991-84.177q-53.559-53.559-84.177-124.949-30.618-71.391-30.618-152.845 0-81.455 30.618-152.387t84.177-124.491 124.949-84.177q71.391-30.618 152.845-30.618 81.455 0 152.387 30.618t124.491 84.177 84.177 124.716 30.618 152.344q0 81.189-30.618 152.621t-84.177 124.991-124.716 84.177-152.344 30.618Z" })));
const ForwardRef = forwardRef(SvgCircleFill);
const Memo = memo(ForwardRef);
export default Memo;
